import React from 'react';
import { useTranslation } from 'react-i18next';
import './FrequencyLayouts.css';

function FrequencyGrid({ frequencies, activeFrequency, favorites = [], onActivate, onToggleFavorite, isDisabled = false }) {
  const { i18n } = useTranslation();
  const isGerman = i18n.language === 'de';

  return (
    <div className="frequency-grid">
      {frequencies.map((freq) => {
        const isActive = activeFrequency?.id === freq.id;
        const isFavorite = favorites.includes(freq.id);
        return (
          <div
            key={freq.id}
            className={`frequency-card ${isActive ? 'active' : ''} ${isDisabled ? 'disabled' : ''}`}
            style={{
              '--freq-color': freq.color_hex,
            }}
            data-testid={`frequency-card-${freq.id}`}
          >
            <button
              className={`favorite-btn ${isFavorite ? 'favorited' : ''}`}
              onClick={() => onToggleFavorite(freq.id)}
              data-testid={`favorite-button-${freq.id}`}
              title={isFavorite 
                ? (isGerman ? 'Aus Favoriten entfernen' : 'Remove from favorites') 
                : (isGerman ? 'Zu Favoriten hinzufügen' : 'Add to favorites')}
            >
              <svg width="20" height="20" viewBox="0 0 20 20" fill={isFavorite ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth="2">
                <path d="M10 2l2.5 6.5L19 9.5l-5.5 4.5L15 20l-5-3.5L5 20l1.5-6L1 9.5l6.5-1L10 2z" />
              </svg>
            </button>
            <div className="card-icon" style={{ color: freq.color_hex }}>
              {freq.icon}
            </div>
            <h3 className="card-title">{freq.name}</h3>
            <p className="card-description">{freq.description}</p>
            <button
              className={`card-button ${isActive ? 'active' : ''}`}
              onClick={() => onActivate(freq.id)}
              style={{
                backgroundColor: isActive ? freq.color_hex : 'transparent',
                borderColor: freq.color_hex,
                color: isActive ? '#000' : freq.color_hex,
              }}
              data-testid={`activate-button-${freq.id}`}
            >
              {isActive 
                ? (isGerman ? 'Deaktivieren' : 'Deactivate') 
                : (isGerman ? 'Aktivieren' : 'Activate')}
            </button>
            {isActive && <div className="active-badge">{isGerman ? 'Aktiv' : 'Active'}</div>}
          </div>
        );
      })}
    </div>
  );
}

export default FrequencyGrid;
